var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartCircleActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.44 16.1C27.63 16.1 26.01 16.98 25 18.33C23.99 16.98 22.37 16.1 20.56 16.1C17.49 16.1 15 18.6 15 21.69C15 22.88 15.19 23.98 15.52 25C17.1 30 21.97 32.99 24.38 33.81C24.72 33.93 25.28 33.93 25.62 33.81C28.03 32.99 32.9 30 34.48 25C34.81 23.98 35 22.88 35 21.69C35 18.6 32.51 16.1 29.44 16.1Z",
    fill: "#D63970"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartCircleActive);
export default __webpack_public_path__ + "static/media/heart-circle-active.1362498ab59ca9527d83e0154f3921ea.svg";
export { ForwardRef as ReactComponent };